<template>
  <div style="margin-top:10px;background:#fff;overflow: hidden;border-radius: 5px;padding: 10px;">
    <div style="margin-bottom:10px;">
      <a-button type="danger" icon="plus" class="bt-button" style="float:right;" @click="$refs.editCoach.show(null)">新增成员</a-button>
      <a-select placeholder="选择职务类型" style="width: 150px" :allowClear="true" v-model="queryParam.staffType" @change="initChange">
        <a-select-option v-for="(item, index) in matchFun.staffTypeEnum()" :value="item.code" :key="index">{{ item.name }}</a-select-option>
      </a-select>
      <a-input-search placeholder="输入姓名、手机号搜索" v-model="queryParam.keyword" @change="initChange" style="width: 200px"/>
      <a-button type="primary" @click="resetQuery">重置</a-button>
      <span class="lesser">共计{{ total }}名成员</span>
    </div>
    <a-table :columns="columns" :data-source="data" :rowKey='record=>record.id' bordered :pagination="false">
      <span slot="image" slot-scope="text, record">
        <img style="width:64px;height:64px;border-radius:5px;" :src="record.image" />
      </span>
      <span slot="type" slot-scope="text">
        <a-tag color="blue">
          {{ matchFun.getLeaderName(text) }}
        </a-tag>
      </span>
      <span slot="programs" slot-scope="text">
        <template v-if="text != null">
          <a-tag v-for="(pr, index) in text.split(',')" :key="index" :color="pr.split(';')[1] === '0' ? 'red':(pr.split(';')[1] === '1' ? 'green':'orange')">
            {{ pr.split(';')[1] }}
          </a-tag>
        </template>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button-group size="small">
          <a-button type="dashed" icon="edit" @click="$refs.editCoach.show(record)">编辑</a-button>
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => deleteCoach(record.id)"
          >
            <a-button type="danger" icon="delete">删除</a-button>
          </a-popconfirm>
        </a-button-group>
      </span>
    </a-table>
    <a-pagination style="margin-top:10px;" v-if="data.length > 0" v-model="current" @change="pageData" :total="total" :pageSize="valData.pageSize" show-less-items />
    <EditCoach ref="editCoach" @ok="refreshAuth"/>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
import EditCoach from './modal/EditCoach'
export default {
  name: 'CenterAuth',
  components: {
    EditCoach
  },
  created () {
    this.initList()
  },
  mounted () {},
  data () {
    return {
      matchFun: matchFun,
      valData: {
        agencyId: this.$route.query.agencyId,
        pageNum: 1,
        pageSize: 20,
        query: ''
      },
      queryParam: {},
      columns: [{
        title: '照片',
        dataIndex: 'image',
        align: 'center',
        scopedSlots: { customRender: 'image' }
      }, {
        title: '姓名',
        dataIndex: 'name',
        align: 'center'
      }, {
        title: '职位',
        dataIndex: 'type',
        align: 'center',
        scopedSlots: { customRender: 'type' }
      }, {
        title: '关联项目',
        dataIndex: 'programs',
        align: 'center',
        scopedSlots: { customRender: 'programs' }
      }, {
        title: '手机号',
        dataIndex: 'mobile',
        align: 'center'
      }, {
        title: '操作',
        align: 'center',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' }
      }],
      current: 1,
      data: [],
      total: 0
    }
  },
  methods: {
    initList () {
      this.valData.query = ''
      if (this.queryParam.staffType || this.queryParam.keyword) {
        this.valData.query += '?'
        if (this.queryParam.staffType) {
          this.valData.query += 'staffType=' + this.queryParam.staffType
        }
        if (this.queryParam.keyword) {
          if (this.valData.query !== '?') {
            this.valData.query += '&'
          }
          this.valData.query += 'keyword=' + this.queryParam.keyword
        }
      }
      this.$api.high.agencyStaffList(this.valData).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.total = res.total
        }
      }).catch(err => {
        console.log(err)
      })
    },
    pageData (pageNum) {
      this.valData.pageNum = pageNum
      this.initList()
    },
    initChange () {
      this.valData.pageNum = 1
      this.initList()
    },
    refreshAuth () {
      this.initList()
    },
    resetQuery () {
      this.valData = {
        agencyId: this.$route.query.agencyId,
        pageNum: 1,
        pageSize: 20,
        query: ''
      }
      this.queryParam = {}
      this.initList()
    },
    deleteCoach (id) {
      this.$api.match.agencyStaffDel({agencyId: this.$route.query.agencyId, id: id}).then(res => {
        if (res.status === 0) {
          this.$message.success(`成功`)
          this.initList()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.BottomButton{
    margin: 50px 0;
    text-align: center;
    div{
        background-color: #d60701;
        padding: 10px 25px;
        width: 160px;
        color: #fff;
        margin: 0 auto;
        border-radius: 2px;
        cursor: pointer;
        text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/center/CenterCoach.vue